<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";

    export let document = null;
    export let categories = [];
    export let closeCallback;

    let fileInput;
    let fileObj = null;

    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Το έγγραφο ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            if (err.message) {
                if (err.code && err.code === 'upload_file_invalid') {
                    Alert.warning("Μεταφόρτωση αρχείου", "Ο τύπος του αρχείου που επιλέξατε δεν είναι έγκυρος τύπος εγγράφου.\nΕπιτρέπονται μόνο αρχεία Word, Excel ή Pdf.");
                    return;
                }
                Notifier.showError(err.message);
            }
        };

        if (!document.document_category_id) {
            Notifier.showError("Επιλέξτε κατηγορία για το έγγραφο!");
            setFocusTo("category");
            return;
        }

        document.title = document.title.trim();
        if (!document.title) {
            Notifier.showError("Πληκτρολογήστε τον τίτλο του εγγράφου!");
            setFocusTo("title");
            return;
        }

        // let action = document.id == 0 ? 'create' : 'edit';
        if (document.id == 0) {
            if (!fileObj) {
                Notifier.showError("Δεν έχετε επιλέξει το αρχείο του εγγράφου!");
                return;
            }

            R.handle(R.document.create, {document, file:fileObj}, onSuccess, onFailure, LOADER.POPUP);
        } else {
            R.handle(R.document.edit, document, onSuccess, onFailure, LOADER.POPUP);
        }
    }

    const onFileSelected = event => {
        fileObj = event.target.files[0];
        document.document_filename = fileObj.name;
    }

    const close = (param) => {
        document = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }
</script>

{#if document}
    <Modal title="Έγγραφο" modalMd on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <select class="form-select" id="category" bind:value="{ document.document_category_id }">
                    <option value="">Κατηγορία</option>
                    {#each categories as category}
                        <option value="{ category.id}">{ category.name }</option>
                    {/each}
                </select>
            </div>
            <div class="form-group">
                <label>Τίτλος</label>
                <input type="text" class="form-control" id="title" bind:value="{ document.title }">
            </div>
            <div class="form-group">
                <label>Περιγραφή</label>
                <textarea class="form-control" bind:value="{ document.description}"></textarea>
            </div>
            <div class="form-group">
                <label>Αρχείο</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" value="{ document.document_filename }"
                           placeholder="επιλέξτε έγγραφο" readonly>
                    {#if document.id == 0}
                        <button class="btn btn-default" type="button" on:click="{ ()=>{fileInput.click()} }">
                            Επιλογή
                        </button>
                    {/if}
                </div>
            </div>
            <div class="form-group">
                <Checkbox label="Ενεργό έγγραφο" bind:checked="{ document.is_active }"/>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>

            <input style="display:none" type="file" accept=".pdf, .xls, .xlsx, .doc, .docx"
                   on:change={ (event) => onFileSelected(event) }
                   bind:this={ fileInput }>
        </div>
    </Modal>
{/if}